export const FETCH_STREET_GEO_JSON_REQUEST = 'map/FETCH_STREET_GEO_JSON_REQUEST';
export const FETCH_STREET_GEO_JSON_SUCCESS = 'map/FETCH_STREET_GEO_JSON_SUCCESS';
export const FETCH_STREET_GEO_JSON_FAILURE = 'map/FETCH_STREET_GEO_JSON_FAILURE';

 
 


export const UPDATE_FIELD = 'map/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'map/SET_DEFAULT_DATA';
